import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "vehicle-card__wrapper" };
const _hoisted_2 = { class: "vehicle-card__logo" };
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = { class: "vehicle-card__info" };
const _hoisted_5 = { class: "vehicle-card__brand" };
const _hoisted_6 = { class: "vehicle-card__info" };
const _hoisted_7 = { class: "vehicle-card__class" };
const _hoisted_8 = { class: "vehicle-card__info vehicle-card__info--model" };
const _hoisted_9 = { class: "vehicle-card__model" };
const _hoisted_10 = { class: "vehicle-card__info" };
const _hoisted_11 = { class: "vehicle-card__years" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'VehicleCard',
    props: {
        type: {},
        selectedMake: {},
        selectedModel: {},
        compactView: { type: Boolean }
    },
    emits: ["select"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        // Fallback to selected make/model from MakeModelSearch when API returns null
        function displayMakeTitle() {
            return props.type.make_title ?? props.selectedMake?.title ?? '';
        }
        function displayModelTitle() {
            return props.type.model_title ?? props.selectedModel?.title ?? '';
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "vehicle-types-list__item",
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('select', __props.type)))
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass(["vehicle-card", props.compactView ? 'vehicle-card--compact' : ''])
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("img", {
                                src: __props.type.make_image ?? __props.selectedMake?.image,
                                alt: displayMakeTitle(),
                                width: "50px",
                                class: "vehicle-card__logo-img"
                            }, null, 8, _hoisted_3)
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("span", _hoisted_5, _toDisplayString(displayMakeTitle()), 1)
                        ]),
                        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "vehicle-card__divider" }, [
                            _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "26",
                                height: "68",
                                viewBox: "0 0 26 68",
                                fill: "none"
                            }, [
                                _createElementVNode("path", {
                                    d: "M20.3116 0H26L6 68H0L20.3116 0Z",
                                    fill: "#FFED00"
                                })
                            ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("span", _hoisted_7, _toDisplayString(displayModelTitle()), 1)
                        ]),
                        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "vehicle-card__divider" }, [
                            _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "26",
                                height: "68",
                                viewBox: "0 0 26 68",
                                fill: "none"
                            }, [
                                _createElementVNode("path", {
                                    d: "M20.3116 0H26L6 68H0L20.3116 0Z",
                                    fill: "#FFED00"
                                })
                            ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("span", _hoisted_9, _toDisplayString(__props.type.title), 1)
                        ]),
                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "vehicle-card__divider" }, [
                            _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "26",
                                height: "68",
                                viewBox: "0 0 26 68",
                                fill: "none"
                            }, [
                                _createElementVNode("path", {
                                    d: "M20.3116 0H26L6 68H0L20.3116 0Z",
                                    fill: "#FFED00"
                                })
                            ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("span", _hoisted_11, _toDisplayString(__props.type.year_start) + " - " + _toDisplayString(__props.type.year_end), 1)
                        ])
                    ]),
                    _cache[4] || (_cache[4] = _createElementVNode("button", { class: "vehicle-card__arrow" }, [
                        _createElementVNode("div", { class: "vehicle-card__arrow-bg" }),
                        _createElementVNode("svg", {
                            class: "vehicle-card__arrow-icon",
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "19",
                            height: "34",
                            viewBox: "0 0 19 34",
                            fill: "none"
                        }, [
                            _createElementVNode("path", {
                                d: "M0.707031 0.707153L16.707 16.7072L0.707031 32.7072",
                                stroke: "#33363F",
                                "stroke-width": "2"
                            })
                        ])
                    ], -1))
                ], 2)
            ]));
        };
    }
});
